// MB in the file-manager limits means 1,000,000 bytes. Chunks use MiB.
export const UPLOAD_CHUNK_BYTES = 5 * 1024 * 1024;
export const UPLOAD_BODY_BYTES = 6 * 1024 * 1024;
export const UPLOAD_DOCUMENT_BYTES = 80 * 1000 * 1000;
export const UPLOAD_PACKAGE_BYTES = 100 * 1000 * 1000;
export const UPLOAD_PACKAGE_FILES = 10;
export const UPLOAD_VIDEO_BYTES = 2 * 1024 ** 3;
export const DOCUMENT_UPLOAD_FORMATS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'xls', 'xlsx',
  'csv', 'pdf', 'txt', 'doc', 'docx', 'ppt', 'pptx'];
export const VIDEO_UPLOAD_FORMATS = ['mp4', 'm4v'];
export function uploadSizeLimit(format: string): number {
  if (VIDEO_UPLOAD_FORMATS.includes(format)) return UPLOAD_VIDEO_BYTES;
  if (DOCUMENT_UPLOAD_FORMATS.includes(format)) return UPLOAD_DOCUMENT_BYTES;
  throw new Error('Unsupported upload format');
}
